module.exports = __webpack_public_path__ + "static/media/zero_to_one.a26a80e4.avif";